import * as t from "io-ts";
export const driverNotificationTypeTextT = t.literal("TEXT");
export const driverNotificationTypeRouteUpdatedT = t.literal("ROUTE_UPDATED");
export const driverNotificationTypeStopDocumentsAddedT = t.literal("STOP_DOCUMENTS_ADDED");
export const driverNotificationTypeT = t.union([
    driverNotificationTypeTextT,
    driverNotificationTypeRouteUpdatedT,
    driverNotificationTypeStopDocumentsAddedT,
]);
export const notificationTextRouteChangedT = t.literal("notificationTextRouteChanged");
export const driverNotificationTextPropsT = t.strict({
    type: driverNotificationTypeTextT,
    data: t.strict({
        text: t.string,
    }),
});
const driverNotificationRouteUpdatedLineStopReorderedT = t.strict({
    type: t.literal("STOPS_REORDERED"),
});
const driverNotificationRouteUpdatedLineStopsAddedT = t.strict({
    type: t.literal("STOPS_ADDED"),
});
const driverNotificationRouteUpdatedLineStopsRemovedT = t.strict({
    type: t.literal("STOPS_REMOVED"),
});
const driverNotificationRouteUpdatedLineStopUpdatedT = t.strict({
    type: t.literal("STOPS_UPDATED"),
    data: t.strict({
        stopName: t.string,
        property: t.union([
            t.literal("OPENING_DATE"),
            t.literal("OPENING_TIME"),
            t.literal("ADDRESS"),
            t.literal("DIMENSION_LOADMETERS"),
            t.literal("DIMENSION_VOLUME"),
            t.literal("DIMENSION_WEIGHT"),
            t.literal("DIMENSION_HEIGHT"),
            t.literal("DIMENSION_WIDTH"),
            t.literal("DIMENSION_LENGTH"),
        ]),
        from: t.string,
        to: t.string,
    }),
});
const driverNotificationRouteUpdatedLineT = t.union([
    driverNotificationRouteUpdatedLineStopReorderedT,
    driverNotificationRouteUpdatedLineStopsAddedT,
    driverNotificationRouteUpdatedLineStopsRemovedT,
    driverNotificationRouteUpdatedLineStopUpdatedT,
]);
export const driverNotificationRouteUpdatedPropsT = t.strict({
    type: driverNotificationTypeRouteUpdatedT,
    data: t.strict({
        changes: t.array(driverNotificationRouteUpdatedLineT),
        routeId: t.string,
    }),
});
export const driverNotificationStopDocumentsAddedPropsT = t.strict({
    type: t.literal("STOP_DOCUMENTS_ADDED"),
    data: t.strict({
        routeId: t.string,
        stopName: t.string,
    }),
});
export const driverNotificationPropsT = t.union([
    driverNotificationTextPropsT,
    driverNotificationRouteUpdatedPropsT,
    driverNotificationStopDocumentsAddedPropsT,
]);
export const createDriverNotificationTypes = ({ dateTime, }) => {
    const driverNotificationBaseT = t.strict({
        id: t.string,
        type: driverNotificationTypeT,
        timestamp: dateTime,
    });
    const driverNotificationTextT = t.intersection([
        driverNotificationBaseT,
        driverNotificationTextPropsT,
    ]);
    const driverNotificationRouteUpdatedT = t.intersection([
        driverNotificationBaseT,
        driverNotificationRouteUpdatedPropsT,
    ]);
    const driverNotificationStopDocumentsAddedT = t.intersection([
        driverNotificationBaseT,
        driverNotificationStopDocumentsAddedPropsT,
    ]);
    const driverNotificationT = t.union([
        driverNotificationTextT,
        driverNotificationRouteUpdatedT,
        driverNotificationStopDocumentsAddedT,
    ]);
    const driverNotificationsT = t.array(driverNotificationT);
    const driverPushNotificationRouteUpdatedDataT = t.strict({
        type: t.literal("ROUTE_UPDATED"),
        data: t.strict({
            routeId: t.string,
        }),
    });
    const driverPushNotificationStopDocumentsAddedDataT = t.strict({
        type: t.literal("STOP_DOCUMENTS_ADDED"),
        data: t.strict({
            routeId: t.string,
            stopName: t.string,
        }),
    });
    const driverPushNotificationDataT = t.union([
        driverPushNotificationRouteUpdatedDataT,
        driverPushNotificationStopDocumentsAddedDataT,
        t.strict({
            type: t.literal("UNKNOWN"),
            data: t.any,
        }),
    ]);
    return {
        driverNotificationBaseT,
        driverNotificationT,
        driverNotificationsT,
        driverNotificationTextT,
        driverNotificationRouteUpdatedT,
        driverNotificationStopDocumentsAddedT,
        driverPushNotificationRouteUpdatedDataT,
        driverPushNotificationStopDocumentsAddedDataT,
        driverPushNotificationDataT,
        driverNotificationRouteUpdatedLineT,
    };
};
//# sourceMappingURL=driver-notifications.js.map